var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "message meta-post-message" }, [
    _vm.getMetaText()
      ? _c("div", { staticClass: "meta-header" }, [
          _c("i", { staticClass: "material-icons" }, [_vm._v("info")]),
          _vm._v("\n        " + _vm._s(_vm.getMetaText()) + "\n    "),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "body" }, [
      _vm.isImage()
        ? _c(
            "div",
            {
              staticClass: "image-post",
              on: {
                mouseenter: function ($event) {
                  _vm.hovered = true
                },
                mouseleave: function ($event) {
                  _vm.hovered = false
                },
              },
            },
            [
              _vm.imageSrc()
                ? _c(
                    "viewer",
                    {
                      attrs: {
                        id: "imageViewer-" + _vm.getId(),
                        images: [_vm.imageSrc()],
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                followCursor: true,
                                placement: "bottom-end",
                              },
                              expression:
                                "{ followCursor: true, placement: 'bottom-end' }",
                            },
                          ],
                          staticClass: "cb-img-preview",
                          attrs: { content: _vm.$t("chatbotv2.imageView") },
                          on: { click: _vm.show },
                        },
                        [
                          _c("img", {
                            staticClass:
                              "img-thumbnail ant-upload-list-picture-card-container",
                            staticStyle: { "object-fit": "cover" },
                            attrs: {
                              id: "img-" + _vm.getId(),
                              src: _vm.imageSrc(),
                            },
                          }),
                          _vm._v(" "),
                          _vm.hovered
                            ? _c("md-icon", { staticClass: "cb-pr-icon" }, [
                                _vm._v(" visibility"),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm.isVideo()
        ? _c(
            "div",
            { staticClass: "video-post" },
            [
              _c("video-player", {
                ref: "videoPlayer",
                staticClass: "video-player-box",
                attrs: { options: _vm.playerOptions(), playsinline: true },
              }),
            ],
            1
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "caption" }, [
      _vm._v("\n        " + _vm._s(_vm.meta.caption) + "\n    "),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "footer" }, [
      _c("div", { staticClass: "count-stats" }, [
        _c("span", { staticClass: "count-stat-item" }, [
          _vm._v(_vm._s(_vm.meta.likeCount) + " "),
          _c("i", { staticClass: "material-icons" }, [_vm._v("thumb_up")]),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "count-stat-item" }, [
          _vm._v(_vm._s(_vm.meta.commentCount) + " "),
          _c("i", { staticClass: "material-icons" }, [_vm._v("chat_bubble")]),
        ]),
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.meta.timestamp))]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }